// extracted by mini-css-extract-plugin
export default {"downloadButton":"adtCz4Cv"};